import { render, staticRenderFns } from "./AsfDebugBar.vue?vue&type=template&id=4bf57306"
import script from "./AsfDebugBar.vue?vue&type=script&lang=js"
export * from "./AsfDebugBar.vue?vue&type=script&lang=js"
import style0 from "./AsfDebugBar.vue?vue&type=style&index=0&id=4bf57306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports